module.exports = __webpack_public_path__ + "img/p.3fbc4228.webp";